import * as Period from '../../../../constants/Period';
var BOXING_PERIOD_MAP = {};
BOXING_PERIOD_MAP[500] = Period.NOT_STARTED;
BOXING_PERIOD_MAP[501] = Period.FIRST;
BOXING_PERIOD_MAP[502] = Period.SECOND;
BOXING_PERIOD_MAP[503] = Period.THIRD;
BOXING_PERIOD_MAP[504] = Period.FOURTH;
BOXING_PERIOD_MAP[505] = Period.FIFTH;
BOXING_PERIOD_MAP[506] = Period.SIXTH;
BOXING_PERIOD_MAP[507] = Period.SEVENTH;
BOXING_PERIOD_MAP[508] = Period.EIGHTH;
BOXING_PERIOD_MAP[509] = Period.NINETH;
BOXING_PERIOD_MAP[510] = Period.TENTH;
BOXING_PERIOD_MAP[511] = Period.ELEVENTH;
BOXING_PERIOD_MAP[512] = Period.TWELFTH;
BOXING_PERIOD_MAP[513] = Period.FINISHED;
export default BOXING_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/Boxing/PeriodMap.js